import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  admin,
  admin_post,
  admin_patch,
  admin_project_sites,
  admin_bulk_gift_configs,
  admin_declaration_configs,
  admin_unmapped_bus,
  admin_sbus,
  admin_sbgs,
  admin_unmapped_project_sites,
  create_or_update_sbu_api,
  create_or_update_sbg_api,
  project_sites,
  project_site_mapping,
  admin_inactive_users,
  admin_assign_gifts,
  admin_map_bus_and_project_sites
} from './api';

const initialState = {
  get_all_usersLoading: false,
  get_all_sbgLoading: false,
  getAll_Entry_delegatorsListLoading: false,
  remove_entry_delegatorLoading: false,
  getAll_approval_delegatorsListLoading: false,
  remove_approval_delegatorLoading: false,
  map_entry_delegatorLoading: false,
  map_approval_delegatorLoading: false,
  get_BU_MasterLoading: false,
  get_admin_sbusLoading: false,
  get_admin_sbgsLoading: false,
  create_or_update_sbuLoading: false,
  create_or_update_sbgLoading: false,
  get_RO_MasterLoading: false,
  get_ROUsers_MasterLoading: false,
  get_Designated_AuthoritiesLoading: false,
  get_Gift_MasterLoading: false,
  create_bu_masterLoading: false,
  create_ro_masterLoading: false,
  create_gift_masterLoading: false,
  create_designated_authoritiesLoading: false,
  remove_bu_masterLoading: false,
  remove_gift_masterLoading: false,
  remove_designated_authoritiesLoading: false,
  get_value_limits_listLoading: false,
  set_value_limitLoading: false,
  get_all_rolesLoading: false,
  set_role_mappingLoading: false,
  set_BU_mappingLoading: false,
  get_project_sitesLoading: false,
  set_project_site_mappingLoading: false,
  getAdminDashboardCountLoading: false,
  getAdminDashboardCountLoadingGifts: false,
  getAdminDashboardCountLoadingStakeHolders: false,
  getAdminDashboardCountLoadingBUs: false,
  getAdminDashboardCountLoadingSectors: false,
  create_ROUsers_masterLoading: false,
  update_ROUsers_masterLoading: false,
  create_or_update_project_siteLoading: false,
  create_bulk_gift_configLoading: false,
  get_admin_bulk_gift_configsLoading: false,
  get_admin_declaration_configsLoading: false,
  get_Senior_Management_FlowLoading: false,
  create_Senior_Management_FlowLoading: false,
  entry_delegatorsList: [],
  approval_delegatorsList: [],
  all_users_List: [],
  all_sbg_List: [],
  admin_sbgsList: [],
  bu_MasterList: [],
  admin_sbusList: [],
  project_sitesList: [],
  ro_MasterList: [],
  roUsers_MasterList: [],
  designated_Authorities_List: [],
  gift_MasterList: [],
  valueLimits_list: [],
  all_roles_list: [],
  acceptedCount: '',
  giftsGiven: '',
  giftsReceived: '',
  numberOfRequests: '',
  pendingCount: '',
  prohibitedCount: '',
  rejectedCount: '',
  returnedCount: '',
  senior_ManagementList: [],
  allGifts: [],
  top5Gifts: [],
  BUs: [],
  stakeHolders: [],
  sectors: [],
  adminProjectSitesLoading: false,
  adminProjectSites: [],
  adminPaginationProjectSites: {},
  adminBulkGiftConfigs: [],
  adminBulkGiftConfigsPagination: {},
  adminDeclarationConfigs: [],
  adminDeclarationConfigsPagination: {},
  create_declaration_configLoading: false,
  admin_unmapped_busLoading: false,
  admin_unmapped_bus: [],
  admin_unmapped_busPagination: {},
  create_admin_unmapped_busLoading: false,
  get_admin_unmapped_project_sitesLoading: false,
  admin_unmapped_project_sitesList: [],
  get_admin_inactive_usersLoading: false,
  admin_inactive_usersList: [],
  admin_inactive_usersPagination: {},
  admin_assign_giftsLoading: false,
  admin_map_bus_and_project_sitesLoading: false
};

const actions = {
  // DECLARE_GIFT_FORM: 'remove_entry_delegator/DECLARE_GIFT_FORM',
  GET_ALL_USERS: 'get_all_users/GET_ALL_USERS',
  GET_ALL_SBG: 'get_all_sbg/GET_ALL_SBG',
  GET_ALL_ENTRY_DELEGATORS_LIST:
    'getAll_Entry_delegatorsList/GET_ALL_ENTRY_DELEGATORS_LIST,',
  REMOVE_ENTRY_DELEGATOR: 'remove_entry_delegator/REMOVE_ENTRY_DELEGATOR',
  GET_ALL_APPROVAL_DELEGATORS_LIST:
    'getAll_approval_delegatorsList/GET_ALL_APPROVAL_DELEGATORS_LIST',
  REMOVE_APPROVAL_DELEGATOR:
    'remove_approval_delegator/REMOVE_APPROVAL_DELEGATOR',
  MAP_ENTRY_DELEGATOR: 'map_entry_delegator/MAP_ENTRY_DELEGATOR',
  MAP_APPROVAL_DELEGATOR: 'map_approval_delegator/MAP_APPROVAL_DELEGATOR',
  GET_BU_MASTER: 'get_BU_Master/GET_BU_MASTER',
  GET_ADMIN_SBUS: 'get_admin_sbus/GET_ADMIN_SBUS',
  GET_PROJECT_SITES: 'get_project_sites/GET_PROJECT_SITES',
  SET_PROJECT_SITE_MAPPING: 'set_project_site_mapping/SET_PROJECT_SITE_MAPPING',
  GET_DESIGNATED_AUTHORITIES:
    'get_Designated_Authorities/GET_DESIGNATED_AUTHORITIES',
  GET_GIFT_MASTER: 'get_Gift_Master/GET_GIFT_MASTER',
  CREATE_DESIGNATED_AUTHORITIES:
    'create_designated_authorities/CREATE_DESIGNATED_AUTHORITIES',
  CREATE_BU_MASTER: 'create_bu_master/CREATE_BU_MASTER',
  CREATE_OR_UPDATE_SBU: 'create_or_update_sbu/CREATE_OR_UPDATE_SBU',
  CREATE_OR_UPDATE_SBG: 'create_or_update_sbg/CREATE_OR_UPDATE_SBG',
  GET_ADMIN_SBGS: 'get_admin_sbgs/GET_ADMIN_SBGS',
  CREATE_GIFT_MASTER: 'create_gift_master/CREATE_GIFT_MASTER',
  REMOVE_BU_MASTER: 'remove_bu_master/REMOVE_BU_MASTER',
  REMOVE_GIFT_MASTER: 'remove_gift_master/REMOVE_GIFT_MASTER',
  REMOVE_DESIGNATED_AUTHORITIES:
    'remove_designated_authorities/REMOVE_DESIGNATED_AUTHORITIES',
  GET_VALUE_LIMITS_LIST: 'get_value_limits_list/GET_VALUE_LIMITS_LIST',
  SET_VALUE_LIMIT: 'set_value_limit/SET_VALUE_LIMIT',
  GET_ALL_ROLES: 'get_all_roles/GET_ALL_ROLES',
  SET_ROLE_MAPPING: 'set_role_mapping/SET_ROLE_MAPPING',
  SET_BU_MAPPING: 'set_BU_mapping/SET_BU_MAPPING',
  GET_ADMIN_DASHBOARD_COUNT: 'getAdminDashboardCount/GET_ADMIN_DASHBOARD_COUNT',
  GET_RO_MASTER: 'get_RO_Master/GET_RO_MASTER',
  CREATE_RO_MASTER: 'create_ro_master/CREATE_RO_MASTER',
  GET_RO_USERS_MASTER: 'get_ROUsers_Master/GET_RO_USERS_MASTER',
  CREATE_RO_USERS_MASTER: 'create_ROUsers_master/CREATE_RO_USERS_MASTER',
  CREATE_OR_UPDATE_PROJECT_SITE:
    'create_or_update_project_site/CREATE_OR_UPDATE_PROJECT_SITE',
  CREATE_BULK_GIFT_CONFIG: 'create_bulk_gift_config/CREATE_BULK_GIFT_CONFIG',
  GET_ADMIN_BULK_GIFT_CONFIGS:
    'get_admin_bulk_gift_configs/GET_ADMIN_BULK_GIFT_CONFIGS',
  GET_ADMIN_DECLARATION_CONFIGS:
    'get_admin_declaration_configs/GET_ADMIN_DECLARATION_CONFIGS',
  GET_SENIOR_MANAGEMENT_FLOW:
    'get_Senior_Management_Flow/GET_SENIOR_MANAGEMENT_FLOW',
  CREATE_SENIOR_MANAGEMENT_FLOW:
    'create_Senior_Management_Flow/CREATE_SENIOR_MANAGEMENT_FLOW',
  UPDATE_RO_USERS_MASTER: 'update_ROUsers_master/UPDATE_RO_USERS_MASTER',
  GET_ADMIN_DASHBOARD_COUNT_BUs:
    'getAdminDashboardCountBUs/GET_ADMIN_DASHBOARD_COUNT_BUs',
  GET_ADMIN_DASHBOARD_COUNT_GIFTS:
    'getAdminDashboardCountGifts/GET_ADMIN_DASHBOARD_COUNT_GIFTS',
  GET_ADMIN_DASHBOARD_COUNT_SECTORS:
    'getAdminDashboardCountSectors/GET_ADMIN_DASHBOARD_COUNT_SECTORS',
  GET_ADMIN_DASHBOARD_COUNT_STAKEHOLDERS:
    'getAdminDashboardCountStakeHolders/GET_ADMIN_DASHBOARD_COUNT_STAKEHOLDERS',
  GET_ADMIN_PROJECT_SITES: 'get_admin_project_sites/GET_ADMIN_PROJECT_SITES',
  GET_ADMIN_UNMAPPED_PROJECT_SITES:
    'get_admin_unmapped_project_sites/GET_ADMIN_UNMAPPED_PROJECT_SITES',
  CREATE_DECLARATION_CONFIG:
    'create_declaration_config/CREATE_DECLARATION_CONFIG',
  ADMIN_UNMAPPED_BUS: 'get_admin_unmapped_bus/ADMIN_UNMAPPED_BUS',
  CREATE_ADMIN_UNMAPPED_BUS:
    'create_admin_unmapped_bus/CREATE_ADMIN_UNMAPPED_BUS',
  GET_ADMIN_INACTIVE_USERS: 'get_admin_inactive_users/GET_ADMIN_INACTIVE_USERS',
  ADMIN_ASSIGN_GIFTS: 'admin_assign_gifts/ADMIN_ASSIGN_GIFTS',
  ADMIN_MAP_BUS_AND_PROJECT_SITES:
    'admin_map_bus_and_project_sites/ADMIN_MAP_BUS_AND_PROJECT_SITES'
};

// export const getAdminProjectSites = createAsyncThunk(
//   actions.GET_ADMIN_PROJECT_SITES,
//   async (payload) => {
//     const response = await admin_project_sites(payload);
//     return response;
//   }
// );
export const get_admin_bulk_gift_configs = createAsyncThunk(
  actions.GET_ADMIN_BULK_GIFT_CONFIGS,
  async (payload) => {
    const response = await admin_bulk_gift_configs(payload);
    return response;
  }
);
export const get_admin_declaration_configs = createAsyncThunk(
  actions.GET_ADMIN_DECLARATION_CONFIGS,
  async (payload) => {
    const response = await admin_declaration_configs(payload);
    return response;
  }
);
export const getAdminDashboardCountBUs = createAsyncThunk(
  actions.GET_ADMIN_DASHBOARD_COUNT_BUs,
  async (payload) => {
    const response = await admin(`admin-dashboard-counts`, payload);
    return response;
  }
);
export const getAdminDashboardCountSectors = createAsyncThunk(
  actions.GET_ADMIN_DASHBOARD_COUNT_SECTORS,
  async (payload) => {
    const response = await admin(`admin-dashboard-counts`, payload);
    return response;
  }
);
export const getAdminDashboardCountStakeHolders = createAsyncThunk(
  actions.GET_ADMIN_DASHBOARD_COUNT_STAKEHOLDERS,
  async (payload) => {
    const response = await admin(`admin-dashboard-counts`, payload);
    return response;
  }
);
export const getAdminDashboardCount = createAsyncThunk(
  actions.GET_ADMIN_DASHBOARD_COUNT,
  async (payload) => {
    const response = await admin(`admin-dashboard-counts`, payload);
    return response;
  }
);
export const getAdminDashboardCountGifts = createAsyncThunk(
  actions.GET_ADMIN_DASHBOARD_COUNT_GIFTS,
  async (payload) => {
    const response = await admin(`admin-dashboard-counts`, payload);
    return response;
  }
);

export const set_BU_mapping = createAsyncThunk(
  actions.SET_BU_MAPPING,
  async (payload) => {
    const response = await admin_post(
      `bu-mapping?userId=${payload?.get('userId')}&buId=${payload?.get(
        'buId'
      )}`,
      payload
    );
    return response;
  }
);

export const set_role_mapping = createAsyncThunk(
  actions.SET_ROLE_MAPPING,
  async (payload) => {
    const response = await admin_post(
      `role-mapping?userId=${payload?.get('userId')}&roleId=${payload?.get(
        'roleId'
      )}`,
      payload
    );
    return response;
  }
);
export const set_value_limit = createAsyncThunk(
  actions.SET_VALUE_LIMIT,
  async (payload) => {
    const response = await admin_post(
      `set-value-limit?limitCategoryId=${payload?.limitCategoryId}&value=${payload?.value}`,
      payload
    );
    return response;
  }
);
export const get_value_limits_list = createAsyncThunk(
  actions.GET_VALUE_LIMITS_LIST,
  async (payload) => {
    const response = await admin(`get-value-limits`, payload);
    return response;
  }
);

export const getAll_Entry_delegatorsList = createAsyncThunk(
  actions.GET_ALL_ENTRY_DELEGATORS_LIST,
  async (payload) => {
    const response = await admin(`all-gift-entry-delegators`, payload);
    return response;
  }
);
export const getAll_approval_delegatorsList = createAsyncThunk(
  actions.GET_ALL_APPROVAL_DELEGATORS_LIST,
  async (payload) => {
    const response = await admin(`all-gift-approval-delegators`, payload);
    return response;
  }
);
export const get_BU_Master = createAsyncThunk(
  actions.GET_BU_MASTER,
  async (payload) => {
    const response = await admin(`bu-master`, payload);
    return response;
  }
);
export const get_admin_inactive_users = createAsyncThunk(
  actions.GET_ADMIN_INACTIVE_USERS,
  async (payload) => {
    const response = await admin_inactive_users(payload);
    return response;
  }
);
export const admin_assign_gifts_action = createAsyncThunk(
  actions.ADMIN_ASSIGN_GIFTS,
  async (payload) => {
    const response = await admin_assign_gifts(payload);
    return response;
  }
);
export const admin_map_bus_and_project_sites_action = createAsyncThunk(
  actions.ADMIN_MAP_BUS_AND_PROJECT_SITES,
  async (payload) => {
    const response = await admin_map_bus_and_project_sites(payload);
    return response;
  }
);
export const get_admin_sbus = createAsyncThunk(
  actions.GET_ADMIN_SBUS,
  async (payload) => {
    const response = await admin_sbus(payload);
    return response;
  }
);
export const get_admin_sbgs = createAsyncThunk(
  actions.GET_ADMIN_SBGS,
  async (payload) => {
    const response = await admin_sbgs(payload);
    return response;
  }
);
export const create_or_update_sbu = createAsyncThunk(
  actions.CREATE_OR_UPDATE_SBU,
  async (payload) => {
    const response = await create_or_update_sbu_api(payload);
    return response;
  }
);
export const create_or_update_sbg = createAsyncThunk(
  actions.CREATE_OR_UPDATE_SBG,
  async (payload) => {
    const response = await create_or_update_sbg_api(payload);
    return response;
  }
);
export const get_RO_Master = createAsyncThunk(
  actions.GET_RO_MASTER,
  async (payload) => {
    const response = await admin(`ro-master`, payload);
    return response;
  }
);
export const get_ROUsers_Master = createAsyncThunk(
  actions.GET_RO_USERS_MASTER,
  async (payload) => {
    const response = await admin(`ro-users`, payload);
    return response;
  }
);
export const get_Designated_Authorities = createAsyncThunk(
  actions.GET_DESIGNATED_AUTHORITIES,
  async (payload) => {
    const response = await admin(`designated-authorities`, payload);
    return response;
  }
);
export const get_Gift_Master = createAsyncThunk(
  actions.GET_GIFT_MASTER,
  async (payload) => {
    const response = await admin(`gift-master`, payload);
    return response;
  }
);

export const remove_entry_delegator = createAsyncThunk(
  actions.REMOVE_ENTRY_DELEGATOR,
  async (payload) => {
    const response = await admin_post(
      `remove-gift-entry-delegator?delegator_id=${payload?.delegator_id}&delegate_id=${payload?.delegate_id}`,
      payload
    );
    return response;
  }
);
export const remove_approval_delegator = createAsyncThunk(
  actions.REMOVE_APPROVAL_DELEGATOR,
  async (payload) => {
    const response = await admin_post(
      `remove-gift-approval-delegator?delegator_id=${payload?.delegator_id}&delegate_id=${payload?.delegate_id}`,
      payload
    );
    return response;
  }
);

export const get_all_users = createAsyncThunk(
  actions.GET_ALL_USERS,
  async (payload) => {
    const response = await admin(`get-all-users`, payload);
    return response;
  }
);
export const get_all_sbg = createAsyncThunk(
  actions.GET_ALL_SBG,
  async (payload) => {
    const response = await admin(`get-all-users`, payload);
    return response;
  }
);
export const get_all_roles = createAsyncThunk(
  actions.GET_ALL_ROLES,
  async (payload) => {
    const response = await admin(`all-roles`, payload);
    return response;
  }
);
export const map_entry_delegator = createAsyncThunk(
  actions.MAP_ENTRY_DELEGATOR,
  async (payload) => {
    const response = await admin_post(
      `map-gift-entry-delegator?delegator_id=${payload?.delegator_id}&delegate_id=${payload?.delegate_id}`,
      payload
    );
    return response;
  }
);
export const map_approval_delegator = createAsyncThunk(
  actions.MAP_APPROVAL_DELEGATOR,
  async (payload) => {
    const response = await admin_post(
      `map-gift-approval-delegator?delegator_id=${payload?.delegator_id}&delegate_id=${payload?.delegate_id}`,
      payload
    );
    return response;
  }
);
export const create_bu_master = createAsyncThunk(
  actions.CREATE_BU_MASTER,
  async (payload) => {
    console.log("payload?.get('id')", payload?.get('id'));
    const response = await admin_post(
      `bu-master?id=${payload?.get('id') === null ? '' : payload?.get('id')}`,
      payload
    );
    return response;
  }
);
export const create_ro_master = createAsyncThunk(
  actions.CREATE_RO_MASTER,
  async (payload) => {
    console.log("payload?.get('id')", payload?.get('id'));
    const response = await admin_post(
      `ro-master?id=${payload?.get('id') === null ? '' : payload?.get('id')}`,
      payload
    );
    return response;
  }
);
export const create_ROUsers_master = createAsyncThunk(
  actions.CREATE_RO_USERS_MASTER,
  async (payload) => {
    const response = await admin_post(`ro-users/create`, payload);
    return response;
  }
);
export const update_ROUsers_master = createAsyncThunk(
  actions.UPDATE_RO_USERS_MASTER,
  async (payload) => {
    const response = await admin_patch(`ro-users/update`, payload);
    return response;
  }
);
export const create_or_update_project_site = createAsyncThunk(
  actions.CREATE_OR_UPDATE_PROJECT_SITE,
  async (payload) => {
    const response = await admin_post(`create-or-update-project-site`, payload);
    return response;
  }
);
export const create_bulk_gift_config = createAsyncThunk(
  actions.CREATE_BULK_GIFT_CONFIG,
  async (payload) => {
    const response = await admin_post(`admin-create-bulk-gift-config`, payload);
    return response;
  }
);
export const remove_bu_master = createAsyncThunk(
  actions.REMOVE_BU_MASTER,
  async (payload) => {
    const response = await admin_post(
      `bu-master?id=${payload?.get('id')}`,
      payload
    );
    return response;
  }
);
export const create_gift_master = createAsyncThunk(
  actions.CREATE_GIFT_MASTER,
  async (payload) => {
    const response = await admin_post(`gift-master`, payload);
    return response;
  }
);
export const remove_gift_master = createAsyncThunk(
  actions.REMOVE_GIFT_MASTER,
  async (payload) => {
    const response = await admin_post(
      `gift-master?id=${payload?.get('id')}`,
      payload
    );
    return response;
  }
);
export const create_designated_authorities = createAsyncThunk(
  actions.CREATE_DESIGNATED_AUTHORITIES,
  async (payload) => {
    const response = await admin_post(
      `designated-authorities?id=${payload?.get('id')}`,
      payload
    );
    return response;
  }
);
export const remove_designated_authorities = createAsyncThunk(
  actions.REMOVE_DESIGNATED_AUTHORITIES,
  async (payload) => {
    const response = await admin_post(
      `designated-authorities?id=${payload?.get('id')}`,
      payload
    );
    return response;
  }
);
export const get_Senior_Management_Flow = createAsyncThunk(
  actions.GET_SENIOR_MANAGEMENT_FLOW,
  async (payload) => {
    const response = await admin(`senior-management`, payload);
    return response;
  }
);
export const create_Senior_Management_Flow = createAsyncThunk(
  actions.CREATE_SENIOR_MANAGEMENT_FLOW,
  async (payload) => {
    const response = await admin_patch(
      `senior-management?oldUserId=${payload?.get(
        'oldUserId'
      )}&newUserId=${payload?.get('newUserId')}`,
      payload
    );
    return response;
  }
);
export const get_admin_project_sites = createAsyncThunk(
  actions.GET_ADMIN_PROJECT_SITES,
  async (payload) => {
    const response = await admin_project_sites(payload);
    return response;
  }
);

export const create_declaration_config = createAsyncThunk(
  actions.CREATE_DECLARATION_CONFIG,
  async (payload) => {
    const response = await admin_post(
      `admin-create-declaration-config`,
      payload
    );
    return response;
  }
);
export const get_admin_unmapped_bus = createAsyncThunk(
  actions.ADMIN_UNMAPPED_BUS,
  async (payload) => {
    const response = await admin_unmapped_bus(payload);
    return response;
  }
);

export const get_admin_unmapped_project_sites = createAsyncThunk(
  actions.GET_ADMIN_UNMAPPED_PROJECT_SITES,
  async (payload) => {
    const response = await admin_unmapped_project_sites(payload);
    return response;
  }
);

export const create_admin_unmapped_bus = createAsyncThunk(
  actions.CREATE_ADMIN_UNMAPPED_BUS,
  async (payload) => {
    const response = await admin_post(
      `admin-map-bus-and-project-sites`,
      payload
    );
    return response;
  }
);

export const get_project_sites = createAsyncThunk(
  actions.GET_PROJECT_SITES,
  async (payload) => {
    const response = await project_sites(payload);
    return response;
  }
);

export const set_project_site_mapping = createAsyncThunk(
  actions.SET_PROJECT_SITE_MAPPING,
  async (payload) => {
    const response = await project_site_mapping(payload);
    return response;
  }
);

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAll_Entry_delegatorsList.pending, (state) => {
        state.getAll_Entry_delegatorsListLoading = true;
      })
      .addCase(getAll_Entry_delegatorsList.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.getAll_Entry_delegatorsListLoading = false;
        state.entry_delegatorsList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(getAll_Entry_delegatorsList.rejected, (state) => {
        state.getAll_Entry_delegatorsListLoading = false;
      });
    builder
      .addCase(remove_entry_delegator.pending, (state) => {
        state.remove_entry_delegatorLoading = true;
      })
      .addCase(remove_entry_delegator.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.remove_entry_delegatorLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(remove_entry_delegator.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.remove_entry_delegatorLoading = false;

        message.error(msg);
      });
    builder
      .addCase(getAll_approval_delegatorsList.pending, (state) => {
        state.getAll_approval_delegatorsListLoading = true;
      })
      .addCase(getAll_approval_delegatorsList.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.getAll_approval_delegatorsListLoading = false;
        state.approval_delegatorsList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(getAll_approval_delegatorsList.rejected, (state) => {
        state.getAll_approval_delegatorsListLoading = false;
      });
    builder
      .addCase(remove_approval_delegator.pending, (state) => {
        state.remove_approval_delegatorLoading = true;
      })
      .addCase(remove_approval_delegator.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.remove_approval_delegatorLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(remove_approval_delegator.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.remove_approval_delegatorLoading = false;

        message.error(msg);
      });
    builder
      .addCase(get_all_users.pending, (state) => {
        state.get_all_usersLoading = true;
      })
      .addCase(get_all_users.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.get_all_usersLoading = false;
        state.all_users_List = data ? data : [];
        state.pagination = pagination || null;

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_all_users.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.get_all_usersLoading = false;

        message.error(msg);
      });
    builder
      .addCase(get_all_sbg.pending, (state) => {
        state.get_all_sbgLoading = true;
      })
      .addCase(get_all_sbg.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.get_all_sbgLoading = false;
        state.all_sbg_List = data ? data : [];
        state.pagination = pagination || null;

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_all_sbg.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.get_all_sbgLoading = false;

        message.error(msg);
      });
    builder
      .addCase(map_entry_delegator.pending, (state) => {
        state.map_entry_delegatorLoading = true;
      })
      .addCase(map_entry_delegator.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.map_entry_delegatorLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(map_entry_delegator.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.map_entry_delegatorLoading = false;

        message.error(msg);
      });
    builder
      .addCase(map_approval_delegator.pending, (state) => {
        state.map_approval_delegatorLoading = true;
      })
      .addCase(map_approval_delegator.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.map_approval_delegatorLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(map_approval_delegator.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.map_approval_delegatorLoading = false;

        message.error(msg);
      });

    builder
      .addCase(get_BU_Master.pending, (state) => {
        state.get_BU_MasterLoading = true;
      })
      .addCase(get_BU_Master.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_BU_MasterLoading = false;
        state.bu_MasterList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_BU_Master.rejected, (state) => {
        state.get_BU_MasterLoading = false;
      });
    builder
      .addCase(get_admin_inactive_users.pending, (state) => {
        state.get_admin_inactive_usersLoading = true;
      })
      .addCase(get_admin_inactive_users.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_admin_inactive_usersLoading = false;
        state.admin_inactive_usersList = data ? data : [];
        state.admin_inactive_usersPagination = pagination || {};
      })
      .addCase(get_admin_inactive_users.rejected, (state) => {
        state.get_admin_inactive_usersLoading = false;
      });
    builder
      .addCase(admin_assign_gifts_action.pending, (state) => {
        state.admin_assign_giftsLoading = true;
      })
      .addCase(admin_assign_gifts_action.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.admin_assign_giftsLoading = false;
        if (success) {
          message.success(msg || 'Gifts assigned successfully');
        } else {
          message.error(msg || 'Failed to assign gifts');
        }
      })
      .addCase(admin_assign_gifts_action.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.admin_assign_giftsLoading = false;
        message.error(msg || 'Failed to assign gifts');
      });
    builder
      .addCase(admin_map_bus_and_project_sites_action.pending, (state) => {
        state.admin_map_bus_and_project_sitesLoading = true;
      })
      .addCase(
        admin_map_bus_and_project_sites_action.fulfilled,
        (state, action) => {
          const { success, msg, message: msgAlt } = action.payload || {};
          state.admin_map_bus_and_project_sitesLoading = false;
          const messageText = msg || msgAlt;
          if (success) {
            message.success(
              messageText || 'BU and project site mapped successfully'
            );
          } else {
            message.error(messageText || 'Failed to map BU and project site');
          }
        }
      )
      .addCase(
        admin_map_bus_and_project_sites_action.rejected,
        (state, action) => {
          const { message: msg } = action.error || {};
          state.admin_map_bus_and_project_sitesLoading = false;
          message.error(msg || 'Failed to map BU and project site');
        }
      );
    builder
      .addCase(get_admin_sbus.pending, (state) => {
        state.get_admin_sbusLoading = true;
      })
      .addCase(get_admin_sbus.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_admin_sbusLoading = false;
        state.admin_sbusList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_admin_sbus.rejected, (state) => {
        state.get_admin_sbusLoading = false;
      });
    builder
      .addCase(get_admin_sbgs.pending, (state) => {
        state.get_admin_sbgsLoading = true;
      })
      .addCase(get_admin_sbgs.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_admin_sbgsLoading = false;
        state.admin_sbgsList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_admin_sbgs.rejected, (state) => {
        state.get_admin_sbgsLoading = false;
      });
    builder
      .addCase(create_or_update_sbu.pending, (state) => {
        state.create_or_update_sbuLoading = true;
      })
      .addCase(create_or_update_sbu.fulfilled, (state, action) => {
        const { success, msg: msg } = action.payload;
        state.create_or_update_sbuLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_or_update_sbu.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_or_update_sbuLoading = false;

        message.error(msg);
      });
    builder
      .addCase(create_or_update_sbg.pending, (state) => {
        state.create_or_update_sbgLoading = true;
      })
      .addCase(create_or_update_sbg.fulfilled, (state, action) => {
        const { success, msg: msg } = action.payload;
        state.create_or_update_sbgLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_or_update_sbg.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_or_update_sbgLoading = false;

        message.error(msg);
      });
    builder
      .addCase(get_RO_Master.pending, (state) => {
        state.get_RO_MasterLoading = true;
      })
      .addCase(get_RO_Master.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_RO_MasterLoading = false;
        state.ro_MasterList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_RO_Master.rejected, (state) => {
        state.get_RO_MasterLoading = false;
      });
    builder
      .addCase(get_ROUsers_Master.pending, (state) => {
        state.get_ROUsers_MasterLoading = true;
      })
      .addCase(get_ROUsers_Master.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_ROUsers_MasterLoading = false;
        state.roUsers_MasterList = data ? data : [];
        state.pagination = pagination || null;
      })
      .addCase(get_ROUsers_Master.rejected, (state) => {
        state.get_ROUsers_MasterLoading = false;
      });
    builder
      .addCase(get_Designated_Authorities.pending, (state) => {
        state.get_Designated_AuthoritiesLoading = true;
      })
      .addCase(get_Designated_Authorities.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_Designated_AuthoritiesLoading = false;
        state.designated_Authorities_List = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_Designated_Authorities.rejected, (state) => {
        state.get_Designated_AuthoritiesLoading = false;
      });

    builder
      .addCase(get_Gift_Master.pending, (state) => {
        state.get_Gift_MasterLoading = true;
      })
      .addCase(get_Gift_Master.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_Gift_MasterLoading = false;
        state.gift_MasterList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_Gift_Master.rejected, (state) => {
        state.get_Gift_MasterLoading = false;
      });
    builder
      .addCase(create_bu_master.pending, (state) => {
        state.create_bu_masterLoading = true;
      })
      .addCase(create_bu_master.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.create_bu_masterLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_bu_master.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_bu_masterLoading = false;

        message.error(msg);
      });

    builder
      .addCase(create_ro_master.pending, (state) => {
        state.create_ro_masterLoading = true;
      })
      .addCase(create_ro_master.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.create_ro_masterLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_ro_master.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_ro_masterLoading = false;

        message.error(msg);
      });
    builder
      .addCase(create_ROUsers_master.pending, (state) => {
        state.create_ROUsers_masterLoading = true;
      })
      .addCase(create_ROUsers_master.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.create_ROUsers_masterLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_ROUsers_master.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_ROUsers_masterLoading = false;

        message.error(msg);
      });
    builder
      .addCase(create_or_update_project_site.pending, (state) => {
        state.create_or_update_project_siteLoading = true;
      })
      .addCase(create_or_update_project_site.fulfilled, (state, action) => {
        const { success, msg: msg } = action.payload;
        state.create_or_update_project_siteLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_or_update_project_site.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_or_update_project_siteLoading = false;

        message.error(msg);
      });
    builder
      .addCase(create_bulk_gift_config.pending, (state) => {
        state.create_bulk_gift_configLoading = true;
      })
      .addCase(create_bulk_gift_config.fulfilled, (state, action) => {
        const { success, msg: msg } = action.payload;
        state.create_bulk_gift_configLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_bulk_gift_config.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_bulk_gift_configLoading = false;

        message.error(msg);
      });
    builder
      .addCase(update_ROUsers_master.pending, (state) => {
        state.update_ROUsers_masterLoading = true;
      })
      .addCase(update_ROUsers_master.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.update_ROUsers_masterLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(update_ROUsers_master.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.update_ROUsers_masterLoading = false;

        message.error(msg);
      });
    builder
      .addCase(create_gift_master.pending, (state) => {
        state.create_gift_masterLoading = true;
      })
      .addCase(create_gift_master.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.create_gift_masterLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_gift_master.rejected, (state, action) => {
        const { msg: msg } = action.error;
        state.create_gift_masterLoading = false;
        message.error(msg);
      });

    builder
      .addCase(create_designated_authorities.pending, (state) => {
        state.create_designated_authoritiesLoading = true;
      })
      .addCase(create_designated_authorities.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.create_designated_authoritiesLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_designated_authorities.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_designated_authoritiesLoading = false;

        message.error(msg);
      });
    builder
      .addCase(remove_bu_master.pending, (state) => {
        state.remove_bu_masterLoading = true;
      })
      .addCase(remove_bu_master.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.remove_bu_masterLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(remove_bu_master.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.remove_bu_masterLoading = false;

        message.error(msg);
      });
    builder
      .addCase(remove_gift_master.pending, (state) => {
        state.remove_gift_masterLoading = true;
      })
      .addCase(remove_gift_master.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.remove_gift_masterLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(remove_gift_master.rejected, (state, action) => {
        const { msg: msg } = action.error;
        state.remove_gift_masterLoading = false;
        message.error(msg);
      });
    builder
      .addCase(remove_designated_authorities.pending, (state) => {
        state.remove_designated_authoritiesLoading = true;
      })
      .addCase(remove_designated_authorities.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.remove_designated_authoritiesLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(remove_designated_authorities.rejected, (state, action) => {
        const { msg: msg } = action.error;
        state.remove_designated_authoritiesLoading = false;
        message.error(msg);
      });
    builder
      .addCase(get_value_limits_list.pending, (state) => {
        state.get_value_limits_listLoading = true;
      })
      .addCase(get_value_limits_list.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_value_limits_listLoading = false;
        state.valueLimits_list = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_value_limits_list.rejected, (state) => {
        state.get_value_limits_listLoading = false;
      });
    builder
      .addCase(set_value_limit.pending, (state) => {
        state.set_value_limitLoading = true;
      })
      .addCase(set_value_limit.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.set_value_limitLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(set_value_limit.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.set_value_limitLoading = false;

        message.error(msg);
      });
    builder
      .addCase(get_all_roles.pending, (state) => {
        state.get_all_rolesLoading = true;
      })
      .addCase(get_all_roles.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.get_all_rolesLoading = false;
        state.all_roles_list = data ? data : [];
        state.pagination = pagination || null;

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_all_roles.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.get_all_rolesLoading = false;

        message.error(msg);
      });
    builder
      .addCase(set_role_mapping.pending, (state) => {
        state.set_role_mappingLoading = true;
      })
      .addCase(set_role_mapping.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.set_role_mappingLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(set_role_mapping.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.set_role_mappingLoading = false;

        message.error(msg);
      });
    builder
      .addCase(set_BU_mapping.pending, (state) => {
        state.set_BU_mappingLoading = true;
      })
      .addCase(set_BU_mapping.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.set_BU_mappingLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(set_BU_mapping.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.set_BU_mappingLoading = false;

        message.error(msg);
      });
    builder
      .addCase(get_project_sites.pending, (state) => {
        state.get_project_sitesLoading = true;
      })
      .addCase(get_project_sites.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_project_sitesLoading = false;
        state.project_sitesList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_project_sites.rejected, (state) => {
        state.get_project_sitesLoading = false;
      });
    builder
      .addCase(set_project_site_mapping.pending, (state) => {
        state.set_project_site_mappingLoading = true;
      })
      .addCase(set_project_site_mapping.fulfilled, (state, action) => {
        const { success, msg: msg } = action.payload;
        state.set_project_site_mappingLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(set_project_site_mapping.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.set_project_site_mappingLoading = false;

        message.error(msg);
      });
    builder
      .addCase(getAdminDashboardCountBUs.pending, (state) => {
        state.getAdminDashboardCountLoadingBUs = true;
      })
      .addCase(getAdminDashboardCountBUs.fulfilled, (state, action) => {
        const { success, msg, BUs } = action.payload;
        state.getAdminDashboardCountLoadingBUs = false;
        if (success) {
          state.BUs = BUs;
        } else {
          message.error(msg);
        }
      })
      .addCase(getAdminDashboardCountBUs.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.getAdminDashboardCountLoadingBUs = false;
        message.error(msg);
      });
    builder
      .addCase(getAdminDashboardCountGifts.pending, (state) => {
        state.getAdminDashboardCountLoadingGifts = true;
      })
      .addCase(getAdminDashboardCountGifts.fulfilled, (state, action) => {
        const { success, msg, allGifts, top5Gifts } = action.payload;
        state.getAdminDashboardCountLoadingGifts = false;
        if (success) {
          state.allGifts = allGifts;
          state.top5Gifts = top5Gifts;
        } else {
          message.error(msg);
        }
      })
      .addCase(getAdminDashboardCountGifts.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.getAdminDashboardCountLoadingGifts = false;
        message.error(msg);
      });
    builder
      .addCase(getAdminDashboardCountStakeHolders.pending, (state) => {
        state.getAdminDashboardCountLoadingStakeHolders = true;
      })
      .addCase(
        getAdminDashboardCountStakeHolders.fulfilled,
        (state, action) => {
          const {
            success,
            msg,
            // allGifts,
            // top5Gifts,
            // sectors,
            // BUs,
            stakeHolders
          } = action.payload;
          state.getAdminDashboardCountLoadingStakeHolders = false;
          if (success) {
            // state.allGifts = allGifts;
            // state.top5Gifts = top5Gifts;
            // state.sectors = sectors;
            // state.BUs = BUs;
            state.stakeHolders = stakeHolders;
          } else {
            message.error(msg);
          }
        }
      )
      .addCase(getAdminDashboardCountStakeHolders.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.getAdminDashboardCountLoadingStakeHolders = false;
        message.error(msg);
      });
    builder
      .addCase(getAdminDashboardCountSectors.pending, (state) => {
        state.getAdminDashboardCountLoadingSectors = true;
      })
      .addCase(getAdminDashboardCountSectors.fulfilled, (state, action) => {
        const {
          success,
          msg,
          // allGifts,
          // top5Gifts,
          sectors
          // BUs,
          // stakeHolders
        } = action.payload;
        state.getAdminDashboardCountLoadingSectors = false;
        if (success) {
          // state.allGifts = allGifts;
          // state.top5Gifts = top5Gifts;
          state.sectors = sectors;
          // state.BUs = BUs;
          // state.stakeHolders = stakeHolders;
        } else {
          message.error(msg);
        }
      })
      .addCase(getAdminDashboardCountSectors.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.getAdminDashboardCountLoadingSectors = false;
        message.error(msg);
      });
    builder
      .addCase(getAdminDashboardCount.pending, (state) => {
        state.getAdminDashboardCountLoading = true;
      })
      .addCase(getAdminDashboardCount.fulfilled, (state, action) => {
        const {
          success,
          acceptedCount,
          giftsGiven,
          giftsReceived,
          numberOfRequests,
          pendingCount,
          prohibitedCount,
          rejectedCount,
          returnedCount,
          msg
        } = action.payload;
        state.getAdminDashboardCountLoading = false;
        if (success) {
          state.acceptedCount = acceptedCount;
          state.giftsGiven = giftsGiven;
          state.giftsReceived = giftsReceived;
          state.numberOfRequests = numberOfRequests;
          state.pendingCount = pendingCount;
          state.prohibitedCount = prohibitedCount;
          state.rejectedCount = rejectedCount;
          state.returnedCount = returnedCount;
        } else {
          message.error(msg);
        }
      })
      .addCase(getAdminDashboardCount.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.getAdminDashboardCountLoading = false;
        message.error(msg);
      });
    builder
      .addCase(get_Senior_Management_Flow.pending, (state) => {
        state.get_Senior_Management_FlowLoading = true;
      })
      .addCase(get_Senior_Management_Flow.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_Senior_Management_FlowLoading = false;
        state.senior_ManagementList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_Senior_Management_Flow.rejected, (state) => {
        state.get_Senior_Management_FlowLoading = false;
      });
    builder
      .addCase(create_Senior_Management_Flow.pending, (state) => {
        state.create_Senior_Management_FlowLoading = true;
      })
      .addCase(create_Senior_Management_Flow.fulfilled, (state, action) => {
        //console.log('declareGiftFormSlice', action.payload);
        const { success, msg: msg } = action.payload;
        state.create_Senior_Management_FlowLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_Senior_Management_Flow.rejected, (state, action) => {
        const { msg: msg } = action.error;

        state.create_Senior_Management_FlowLoading = false;

        message.error(msg);
      });
    builder
      .addCase(get_admin_project_sites.pending, (state) => {
        state.adminProjectSitesLoading = true;
      })
      .addCase(get_admin_project_sites.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.adminProjectSitesLoading = false;
        state.adminProjectSites = data ? data : [];
        state.adminPaginationProjectSites = pagination || null;

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_admin_project_sites.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.adminProjectSitesLoading = false;

        message.error(msg);
      });
    builder
      .addCase(get_admin_bulk_gift_configs.pending, (state) => {
        state.get_admin_bulk_gift_configsLoading = true;
      })
      .addCase(get_admin_bulk_gift_configs.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.get_admin_bulk_gift_configsLoading = false;
        state.adminBulkGiftConfigs = data ? data : [];
        state.adminBulkGiftConfigsPagination = pagination || {};

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_admin_bulk_gift_configs.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.get_admin_bulk_gift_configsLoading = false;

        message.error(msg);
      });
    builder
      .addCase(get_admin_declaration_configs.pending, (state) => {
        state.get_admin_declaration_configsLoading = true;
      })
      .addCase(get_admin_declaration_configs.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.get_admin_declaration_configsLoading = false;
        state.adminDeclarationConfigs = data ? data : [];
        state.adminDeclarationConfigsPagination = pagination || {};

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_admin_declaration_configs.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.get_admin_declaration_configsLoading = false;

        message.error(msg);
      });
    builder
      .addCase(create_declaration_config.pending, (state) => {
        state.create_declaration_configLoading = true;
      })
      .addCase(create_declaration_config.fulfilled, (state, action) => {
        const { success, msg: msg } = action.payload;
        state.create_declaration_configLoading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(create_declaration_config.rejected, (state, action) => {
        const { msg: msg } = action.error;
        state.create_declaration_configLoading = false;
        message.error(msg);
      });
    builder
      .addCase(get_admin_unmapped_bus.pending, (state) => {
        state.admin_unmapped_busLoading = true;
      })
      .addCase(get_admin_unmapped_bus.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.admin_unmapped_busLoading = false;
        state.admin_unmapped_bus = data ? data : [];
        state.admin_unmapped_busPagination = pagination || {};

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_admin_unmapped_bus.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.admin_unmapped_busLoading = false;
        message.error(msg);
      });
    builder
      .addCase(get_admin_unmapped_project_sites.pending, (state) => {
        state.get_admin_unmapped_project_sitesLoading = true;
      })
      .addCase(get_admin_unmapped_project_sites.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.get_admin_unmapped_project_sitesLoading = false;
        state.admin_unmapped_project_sitesList = data ? data : [];

        state.pagination = pagination || null;
      })
      .addCase(get_admin_unmapped_project_sites.rejected, (state) => {
        state.get_admin_unmapped_project_sitesLoading = false;
      });
    builder
      .addCase(create_admin_unmapped_bus.pending, (state) => {
        state.create_admin_unmapped_busLoading = true;
      })
      .addCase(create_admin_unmapped_bus.fulfilled, (state, action) => {
        const { msg: msg } = action.payload;
        state.create_admin_unmapped_busLoading = false;
        message.success(msg);
      })
      .addCase(create_admin_unmapped_bus.rejected, (state, action) => {
        const { msg: msg } = action.error;
        state.create_admin_unmapped_busLoading = false;
        message.error(msg);
      });
  }
});
export default adminSlice.reducer;
